<template>
  <div class="add-member">
    <div class="add-member-warp">
      <account-select-wrapper ref="addSelectWrapper" :contacts="imTeamAddMemberCheckList" type="add" @operate="operate" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AccountSelectWrapper from '../AccountSelectWrapper'
export default {
  name: 'TeamMemberAdd',
  components: {
    AccountSelectWrapper
  },
  props: {
  },
  watch: {
  },
  computed: {
    ...mapState({
      imQyhContactData: state => state.imQyhContactData,
      imTeamAddMemberCheckList: state => state.imTeamAddMemberCheckList,
      imActiveAccount: state => state.imActiveAccount
    })
  },
  data () {
    return {
    }
  },
  methods: {
    ...mapActions(['addTeamMembers']),
    operate (checkList) {
      console.log('checkList', checkList)
      const accounts = checkList.map(item => item.im_accid)
      this.addTeamMembers({teamId: this.imActiveAccount.to, accounts: accounts})
      this.$refs.addSelectWrapper.clearData()
    }
  }
}
</script>

<style lang="stylus" scoped>
.add-member {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.add-member-warp {
  flex-grow: 1;
  max-height: 450px;
}
</style>



// WEBPACK FOOTER //
// src/common/im/team/member/TeamMemberAdd.vue